import {
  ADD_ASSETS, AssetsPayload, UPDATE_ASSET, DELETE_ASSET, EDIT_ASSET, SAVE_ASSET, LOAD_ASSET, ADD_ASSET_LOOKUP, CANCEL_EDIT_ASSET
} from "./types";
import update from "immutability-helper"

const initialState: any = {
  assetEditMode: false,
  selectedAssetId: "",
  initialData: {},
  list: {},
  assetLookupTable: {},
};

export function assetsReducer(
  state = initialState,
  action: AssetsPayload
) {
  switch (action.type) {
    case ADD_ASSETS:
      return update(state, {
        list: {
          [action.data.assetId]: { $set: action.data }
        }
      });
    case ADD_ASSET_LOOKUP:
      return update(state, {
        assetLookupTable: { $set: action.data }
      })
    case DELETE_ASSET:
      return update(state, {
        list: {
          $unset: [action.data]
        }
      })
    case EDIT_ASSET: 
      return {
        ...state,
        assetEditMode: true,
        selectedAssetId: action.data,
        initialData: state.list[action.data],
      }
    case SAVE_ASSET:
      return {
        ...state,
        assetEditMode: false,
        selectedAssetId: "",
        initialData: {},
      }
    case UPDATE_ASSET:
      return update(state, {
        list: {
          [action.data.id]: { $set: action.data.data }
        },
      });
    case LOAD_ASSET:
      return update(state, {
        list: { $set: action.data }
      });
    case CANCEL_EDIT_ASSET:
      return {
        ...state,
        assetEditMode: false,
        selectedAssetId: "",
        initialData: {},
        list: {
          ...state.list,
          [state.selectedAssetId]: state.initialData,
        }
      }
    default:
      return state
  }
}
